/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PromocodeActionObject } from './promocodeActionObject';


export interface PromocodeAction { 
    type?: PromocodeAction.TypeEnum;
    object?: PromocodeActionObject;
}
export namespace PromocodeAction {
    export type TypeEnum = 'discount_percent' | 'discount_abs';
    export const TypeEnum = {
        Percent: 'discount_percent' as TypeEnum,
        Abs: 'discount_abs' as TypeEnum
    };
}


